import $C from './config.js';
import axios from 'axios'
import { Message } from 'element-ui';
export default {
    // 全局配置
    common:{
        baseUrl:$C.apiUrl,
    },
    // get请求
    get(url,data = {},header={}){
        
        let getUrl = this.common.baseUrl + url
        return new Promise((resolve, reject) =>{       
            axios.get(getUrl, {
                params: data,
                headers:header     
            }).then(res => {
                let data = res.data;
                if(data.err_no != 0){
                    Message({
                        message:data.err_msg,
                        type:'error',
                        duration:1500
                    });
                    reject(data)
                }else{
                    resolve(data.data);
                }
            }).catch(err =>{
                reject(err.data)
            })
        })
    },
    // post请求
    post(url,data = {},header={}){
        let postUrl = this.common.baseUrl + url
        return new Promise((resolve, reject) => {
            console.log(header);
            axios.post(postUrl, data,header)
           .then(res => {
               let data = res.data
               if(data.err_no != 0){
                    Message({
                        message:data.err_msg,
                        type:'error',
                        duration:1500
                    });
                    reject(data)
               }else{
                    resolve(data.data);
               }
               
           })
           .catch(err =>{
               reject(err.data)
           })
       });
      
    },
	// 上传文件
	upload(url,data,onProgress = false){
        let uploadUrl = this.common.baseUrl + url
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        let param = new FormData(); //创建form对象
        param.append('image',data.filePath)
        return new Promise((resolve,reject)=>{
            axios.post(uploadUrl, param,config)
           .then(res => {
               resolve(res.data);
           })
           .catch(err =>{
               reject(err.data)
           })
        })
	}
}


// WEBPACK FOOTER //
// ./src/common/request.js